import { useSelector } from "react-redux";

import { selectReviewStages } from "../../../../redux/selectors/reviewStages";
import { selectParentPageStatus } from "../../../../redux/selectors/root";
import { getPageStatusToggleValues } from "../../../../types/templates/campaign-status-toggle/campaign-status-toggle.functions";

import { SelectField } from "../../../forms/fields/select-field/select-field.component";

import { BorderedBlock } from "../bordered-block/bordered-block.component";

import { StatusSectionProps } from "./status-section.props";

export const StatusSection = (props: StatusSectionProps) => {
  const reviewStages = useSelector(selectReviewStages);
  const parentPageStatus = useSelector(selectParentPageStatus(props.pageType));
  const hasWritePermission = props.userPermissions.manageStatus;

  const { disabled, dropdownValues: options } = getPageStatusToggleValues({
    pageType: props.pageType,
    reviewStages,
    hasWritePermission,
    pageStatus: props.form.defaultValues[props.name],
    parentPageStatus,
  });

  const handleChange = () => {
    return props.form.trigger();
  };

  return (
    <BorderedBlock>
      <SelectField
        disabled={disabled}
        form={props.form}
        label={props.label}
        name={props.name}
        onChange={handleChange}
        options={options}
        required={props.required}
        userPermissions={props.userPermissions}
      />
    </BorderedBlock>
  );
};
